import React, {useEffect, useState, useRef, useCallback} from 'react';
import { useDispatch, useSelector } from 'react-redux'
import AddEditComment from '../AddEditComment';
import { Dialog, DialogTitle, DialogContent, DialogActions, Divider, Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Draggable from 'react-draggable';
import {Tooltip } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { useTranslation } from 'react-i18next';

import { BlindScanBatchSetting } from '../BlindScanBatchSetting';
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import { updatescanningstatus, settleUnscannedOrders, createSubBatch, setBlindScanBatch} from '../../../actions/batchManagementActions';
import { openBlindScanBatchSettingDialog } from '../../../actions/batchManagementActions';


const useStyles = makeStyles((theme)=> ({
    dialogPaper: {
        minHeight: '80vh'
    },
    column: {
        display: 'flex', 
        flexFlow: 'column nowrap', 
        justifyContent: 'center'
    },
    row: {
        display: 'flex', 
        flexFlow: 'row nowrap', 
        justifyContent: 'center'
    },
    button: {
        margin: '20px auto 20px auto',
        width: '200px'
    }
}));

function PaperComponent(props) {
    return (
      <Draggable handle="#draggable-dialog-title" cancel={'[class*="MuiDialogContent-root"]'}>
        <Paper {...props} />
      </Draggable>
    )
}
  
export default function ShortcutActionDialog(props) {
    const { openModal, onClose, warehouse, selectedDispatchNo, rows } = props;

    const classes = useStyles();
    const {t} = useTranslation('batchManagement');
    const dispatch = useDispatch();

    // const updateScanStatusResult = useSelector(state => state.batchManagement.updateScanStatusResult) || "";
    // const settleUnscannedOrdersResult = useSelector(state => state.batchManagement.settleUnscannedOrdersResult) || "";
    // const createSubBatchResult = useSelector(state => state.batchManagement.createSubBatchResult) || "";
    // const setBlindScanBatchResult = useSelector(state => state.batchManagement.setBlindScanBatchResult) || "";

    const blindScanBatchSettingDialog = useSelector(state => state.batchManagement.openBlindScanBatchSettingDialog) || false;
    const batchDataList = useSelector(state => state.batchManagement.batchList) || [];

    const [blindScanStatus,setBlindScanStatus] = useState(0);

    // to prevent the contious post , once is submit , it need some time to resubmit
    const [isSubmitted,setIsSubmitted] = useState(false);

    // is dispatchno selected
    const [isDispatchSelected,setIsDispatchSelected] = useState(false);

    const [openModelComment, setOpenModelComment] = useState(false);
    const [commentOri, setCommentOri] = useState('');
    const [moreThanOneBatch, setMoreThanOneBatch] = useState(true);
    const [batches, setBatches] = useState('');
    const [disableBlind, setDisableBlind] = useState(false);


    // useEffect(() => {      
    //     if (updateScanStatusResult) {
    //         if (updateScanStatusResult === "FAIL") {
    //             dispatch(showAlertSnackbar({type: "error", message: "scan status failed, pls retry!"}));
    //         } else {
    //             dispatch(showAlertSnackbar({type: "info", message: "scan status updated, updated recorders :" + updateScanStatusResult['updated']}));
    //         }           
    //     }
    // },[updateScanStatusResult]);      

    // useEffect(() => {      
    //     if (settleUnscannedOrdersResult) {
    //         if (settleUnscannedOrdersResult==="FAIL") {
    //             dispatch(showAlertSnackbar({type: "error", message: "settle unscanned orders failed, pls retry!"}));
    //         } else {
    //             dispatch(showAlertSnackbar({type: "info", message: settleUnscannedOrdersResult['message'] + 
    //             " unscanned: " + settleUnscannedOrdersResult['unscanned'] + " failed: " + settleUnscannedOrdersResult['failed_batches']}));
    //         }                        
    //     } 
    // },[settleUnscannedOrdersResult]);      
    
    // useEffect(() => {      
    //     if (createSubBatchResult) {
    //         if (createSubBatchResult === "FAIL") {
    //             dispatch(showAlertSnackbar({type: "error", message: "create sub batch failed , pls retry! "}));
    //         } else {
    //             dispatch(showAlertSnackbar({type: "info", message: "create sub batch success , sub batch no: " + createSubBatchResult['sub_batch_no'] }));                    
    //         }            
    //     }               
    // },[createSubBatchResult]);      
    

    // useEffect(() => {                
    //     if (setBlindScanBatchResult) {
    //         if (setBlindScanBatchResult === "FAIL") {
    //             dispatch(showAlertSnackbar({type: "error", message: "set blind scan batch failed , pls retry! "}));
    //         } else {
    //             dispatch(showAlertSnackbar({type: "info", message: "set blind scan batch success !" }));
    //         }            
    //     } 
    // },[setBlindScanBatchResult]);      

    useEffect(() => {    
        if (openModal === true && selectedDispatchNo)  {
            //initialization the variable
            init();
        }        
    },[openModal]);

    // Support setting/unsetting more than one blind batche 
    useEffect(() => {
        if(selectedDispatchNo) {
            let count = 0;
            if(selectedDispatchNo.length > 0) {
                selectedDispatchNo.map((dispatches) => {
                    dispatches.mawb.map((dispatch) => {
                        if(dispatch.selected) {
                            count += 1;
                        }
                    })
                })
            }
            if(count < 1) {
                setDisableBlind(true);
            }
        }
    }, [selectedDispatchNo])
    
    return (<>
        <AddEditComment
            openModal={openModelComment}
            onClose={handleBatchCommentClose}
            warehouse={warehouse}
            batches={batches}
            commentOri={commentOri}
        />
        <Dialog 
            open={openModal}
            onClose={handleClose} 
            PaperComponent={PaperComponent}
            aria-labelledby="draggable-dialog-title"
            fullWidth={true}
            maxWidth='sm'
            scroll='body'
        >
            <DialogTitle style={{ cursor: 'move' }} id="draggable-dialog-title">
                {t('title_shortcut_operation')}
                <span style={{float: "right"}}>
                    <Tooltip title={t('common:cancel')} aria-label="cancel" >
                        <CloseIcon onClick={handleClose}></CloseIcon>
                    </Tooltip>        
                </span>
            </DialogTitle>

            <DialogContent>
                <div className={classes.column}>
                    <div className={classes.row}>
                        <Button className={classes.button}
                            variant="outlined" 
                            disabled={isSubmitted || !isDispatchSelected }
                            onClick={ (e) => (handleScanTurnOn(1)) }
                        >
                            {t('button_scan_turn_on')}
                        </Button>

                        <Button className={classes.button}
                            variant="outlined" 
                            disabled={isSubmitted || !isDispatchSelected }
                            onClick={ (e) => (handleScanTurnOn(0)) }
                        >
                            {t('button_scan_turn_off')}
                        </Button>
                    </div>

                    <div className={classes.row}>
                        <Button className={classes.button}
                            variant="outlined" 
                            disabled={isSubmitted || !isDispatchSelected }
                            onClick={handleScanFinish}
                        >
                            {t('button_scan_finish')}
                        </Button>

                        <Button className={classes.button}
                            variant="outlined" 
                            disabled={moreThanOneBatch}
                            onClick={handleBatchAddEditComment}
                        >
                            {t('button_add_edit_batch_comment')}
                        </Button>
                    </div>

                    <Divider/>

                    <div className={classes.row}>
                        <Button className={classes.button}
                            variant="outlined" 
                            disabled={isSubmitted}
                            onClick={handleCreateSubBatch}
                        >
                            {t('button_create_blank_sub_batch')}
                        </Button>
                    </div>

                    <div className={classes.row}>
                        <Button className={classes.button}
                            variant="outlined" 
                            disabled={isSubmitted || disableBlind}
                            onClick={() => {
                                setBlindScanStatus(0);
                                handleSetBlindScanBatch(0);
                            }}
                        >
                            {t('button_set_blind_scan_batch')}
                        </Button>

                        <Button className={classes.button}
                            variant="outlined" 
                            disabled={isSubmitted || disableBlind}
                            onClick={() => {
                                setBlindScanStatus(1);
                                handleSetBlindScanBatch(1);
                            }}
                        >
                            {t('button_unset_blind_scan_batch')}
                        </Button>
                    </div>
                </div>
                
                {
                    blindScanBatchSettingDialog 
                    ?
                    <BlindScanBatchSetting handleClose={handleCloseBlindScanBatchSettingDialog} warehouse={warehouse} flag={blindScanStatus}/>
                    :
                    null
                }                                                       
            </DialogContent> 

            <DialogActions>
                <Button autoFocus onClick={handleClose} color="primary">
                    {t('common:cancel')}
                </Button>
            </DialogActions>                          
        </Dialog>
    </>)


    /**
     * init
     */
    function init() {
        let findSelect = false;
        let count = 0;
        for (let i = 0 ; i < selectedDispatchNo.length ; i ++ ) {
            if (selectedDispatchNo[i].selected) {
                findSelect = true;
                setMoreThanOneBatch(false);
                const batches = selectedDispatchNo[i].mawb;
                for(let j = 0; j < batches.length; j++) {
                    if(batches[j].selected) {
                        count += 1;
                        const comment = rows.find(batch => batch.master_air_waybill + '' === batches[j].master_air_waybill + '');
                        setCommentOri(comment.description);
                        setBatches(comment.master_air_waybill);
                        if(count > 1) {
                            setMoreThanOneBatch(true);
                            setCommentOri('');
                            setBatches('');
                            break;
                        }
                    }
                }
            }
        }        
        setIsDispatchSelected(findSelect);
        //setIsSubmitted(!findSelect);
    };

    /**
     * Close the MessageSnackbar
     * Call the prarent function to handle the status after this dialoge is closed
     */
    function handleClose() {    
        onClose();
    };


    /**
     * handle scan turn on
     */
    function handleScanTurnOn(value) {
        preventFrequentPost();

        //let branch = localStorage.getItem("warehouse"); 

        let branch = warehouse;
        // if (!branch)
        // // for test only
        // //branch = 1;

        if (!branch) {
            dispatch(showAlertSnackbar({type: "error", message: "scann need your warehouse location, can't find for some reason , pls check!"}));
            return;
        }

        let str = getSelectDispatchNoStr();        
        if (!str) {
            dispatch(showAlertSnackbar({type: "error", message: "no batch was selected!"}));
            return;
        }

        let params = {
            'branch' : branch,
            'batch_nos': str,
            'enabled': value
        }

        //dispatch(updatescanningstatus(params));
         dispatch(updatescanningstatus(params)).then((updateScanStatusResult,isError)=>{
            if (updateScanStatusResult) {
                dispatch(showAlertSnackbar({type: "info", message: "scan status updated, updated recorders :" + updateScanStatusResult['updated']}));
            } else {
                dispatch(showAlertSnackbar({type: "error", message: "scan status failed, pls retry!"}));
            }
         });
    }


    /**
     * setting scan finish
     * @returns 
     */
    function handleScanFinish() {
        preventFrequentPost();

        let str = getSelectDispatchNoStr();        
        if (!str) {
            dispatch(showAlertSnackbar({type: "error", message: "no batch was selected!"}));
            return;
        }
        
        let params = {
            'batch_nos': str,
            'version': 1,
        }

        //dispatch(settleUnscannedOrders(params));
        dispatch(settleUnscannedOrders(params)).then((settleUnscannedOrdersResult)=>{
            if (settleUnscannedOrdersResult) {
                dispatch(showAlertSnackbar({type: "info", message: settleUnscannedOrdersResult['message'] + 
                    " unscanned: " + settleUnscannedOrders['unscanned'] + settleUnscannedOrdersResult['failed_batches']}));
            } else {
                dispatch(showAlertSnackbar({type: "error", message: "settle unscanned orders failed, pls retry!"}));
            }            
        });
    }

    /**
     * create sub batch
     */
    function handleCreateSubBatch() {
        preventFrequentPost();

        // let str = getSelectDispatchNoStr();        
        // if (!str) {
        //     dispatch(showAlertSnackbar({type: "error", message: "no batch was selected!"}));
        //     return;
        // }

        if (!warehouse) {
            dispatch(showAlertSnackbar({type: "error", message: "no warehouse was selected!"}));
            return;
        }        

        let params = {
            //'batch_nos': str,
            'warehouse': warehouse,
            'is_default': 1,
            'version': 1,
        }

        //dispatch(createSubBatch(params));
        dispatch(createSubBatch(params)).then(createSubBatchResult=>{
            if (createSubBatchResult) {
                window.localStorage.setItem('blank_sub_batch_no',createSubBatchResult['sub_batch_no']);
                dispatch(showAlertSnackbar({type: "info", message: "create sub batch success , sub batch no: " + createSubBatchResult['sub_batch_no'] }));                    
            } else {
                dispatch(showAlertSnackbar({type: "error", message: "create sub batch failed , pls retry! "}));
            }               
        }); 
    }

    /**
     * 1.get blind scan batch no by call getBlindScanBatch 
     * 2.update the blind scan status
     * flag: 0 = set blind batch scan
     *       1 = unset blind batch scan
     */
    function handleSetBlindScanBatch(flag) {
        let msg = flag ? 'unset' : 'set';

        preventFrequentPost();
                
        if (!warehouse) {
            dispatch(showAlertSnackbar({type: "error", message: "no warehouse was selected!"}));
            return;
        }

        let str = getSelectDispatchNoStr();     
        // if (!str) {
        //     dispatch(openBlindScanBatchSettingDialog(true));      
        //     return;
        // } 

        let params = {
            'blind_scan_batch': str,
            'warehouse': warehouse,
            'off': flag
        }

        dispatch(setBlindScanBatch(params))
        .then((setBlindScanBatchResult) => {
            if (setBlindScanBatchResult) {
                dispatch(showAlertSnackbar({type: "success", message: `${msg} blind scan success!` }));
            } else {
                dispatch(showAlertSnackbar({type: "error", message: `${msg} blind scan failed , please retry!`}));
            }                
        });

    }

    function getSelectDispatchNoStr() {
        let str = "";
        for (let i = 0; i < selectedDispatchNo.length; i ++ ) {
            if (selectedDispatchNo[i].selected) {
                for (let j = 0; j < selectedDispatchNo[i].mawb.length; j++ ) {
                    if (selectedDispatchNo[i].mawb[j].selected) {
                        str += selectedDispatchNo[i].mawb[j].master_air_waybill;
                        str += ",";    
                    }
                }
            }
        }

        if (str.length > 1) 
            str = str.substring(0,str.lastIndexOf(','));
        
        return str;
    }


    /**
     * to prevent the frequent post which may cause the unnecessary database burden, the user could only repost after 1 second
     */
     function preventFrequentPost() {
        setIsSubmitted(true, 
            setTimeout(() => setIsSubmitted(false), 1000)
        );    
    }
    /**
     * add or edit comment to batch(es)
     */
    function handleBatchAddEditComment() {
        setOpenModelComment(true);
    }
    function handleBatchCommentClose() {
        setOpenModelComment(false);
    }

    /**
     * Close Blind Batch Setting
     */
    function handleCloseBlindScanBatchSettingDialog() {
        dispatch(openBlindScanBatchSettingDialog(false));        
    }

}

